<section class="table-page fise-form-modal">
  <header class="fise-form-modal__header">
    <div class="fise-form-modal__title-wrap">
      <div class="fise-form-modal__icon">
        <mat-icon>person</mat-icon>
      </div>
      <div>
        <h2>{{ tituloOperacion }} usuario</h2>
        <p>Información y privilegios del usuario</p>
      </div>
    </div>

    <button type="button" mat-icon-button class="fise-form-modal__close" (click)="onClicCerrarModal()" aria-label="Cerrar modal">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form class="fise-form-modal__body" [formGroup]="formGroupUsuario">
    <mat-form-field appearance="outline">
      <mat-label>Nombre de usuario</mat-label>
      <input aria-label="Nombre de usuario" matInput type="text" id="nombreUsuario" name="nombreUsuario" [(ngModel)]="objectUusuario.usuario" formControlName="controlNUsuario" maxlength="30" oninput="this.value = this.value.trim()" required>
      <mat-error *ngIf="formUsuar.controlNUsuario.dirty && formUsuar.controlNUsuario.errors">El nombre de usuario es obligatorio.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Contraseña</mat-label>
      <input aria-label="Contraseña" matInput type="password" id="contrasenia" name="contrasenia" [(ngModel)]="objectUusuario.password" formControlName="controlPass" maxlength="100" oninput="this.value = this.value.trim()" required>
      <mat-error *ngIf="formUsuar.controlPass.dirty && formUsuar.controlPass.errors">La contraseña es obligatoria.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Descripción</mat-label>
      <textarea aria-label="Descripción" matInput name="descripcion" rows="3" [(ngModel)]="objectUusuario.descripcion" formControlName="controlDesc" maxlength="100" oninput="this.value = this.value.trimLeft()"></textarea>
      <mat-error *ngIf="formUsuar.controlDesc.dirty && formUsuar.controlDesc.errors">Agregue una breve descripción.</mat-error>
    </mat-form-field>

    <div class="fise-form-modal__radio-group">
      <span>Privilegios</span>
      <mat-radio-group aria-label="Privilegios de usuario" [(ngModel)]="objectUusuario.tipo_usuario" formControlName="controlPrivilegios" required>
        <mat-radio-button value="Admin">Administrador</mat-radio-button>
        <mat-radio-button value="Usuario">Usuario</mat-radio-button>
      </mat-radio-group>
    </div>
  </form>

  <footer class="fise-form-modal__footer" mat-dialog-actions>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--secondary fise-form-modal__cancel" (click)="onClicCerrarModal()">Cancelar</button>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary fise-form-modal__save" (click)="onClicGuardar()" [disabled]="formGroupUsuario.invalid">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </footer>
</section>
